import {UserModel} from 'app/modules/auth/models/UserModel'
import {useSelector, shallowEqual} from 'react-redux'
import {RootState} from 'setup'

const UseLogin = () => {
  const user: UserModel = useSelector<RootState>(({auth}) => auth.user, shallowEqual) as UserModel
  return user
}

export default UseLogin
